import { Component, Input, Output, EventEmitter, Inject, OnInit, OnDestroy, Optional } from '@angular/core';
import { BllAccordionWorkflowComponent } from './accordion-workflow.component';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BllExpandPanelComponent } from '../expand';
import { bllExpansionAnimations } from '../expand/expansion-animations';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'bll-accordion-workflow-panel',
  templateUrl: './accordion-workflow-panel.component.html',
  host: {
    class: 'expand-item',
    '[class.open]': 'isOpen',
    '[class.disabled]': '!noDisabledClass && disabled',
  },
  animations: [bllExpansionAnimations.bodyExpansion],
})
@Input()
export class BllAccordionWorkflowPanelComponent extends BllExpandPanelComponent implements OnInit, OnDestroy {
  @Input() controlGroup: FormGroup;
  get iconCenter(): any {
    return this._iconCenter != null ? this._iconCenter : this.accordion ? this.accordion.iconCenter : true;
  }
  set iconCenter(value: any) {
    this._iconCenter = coerceBooleanProperty(value);
  }
  private _iconCenter: boolean;
  @Input()
  get iconClass(): string {
    return this.accordion?.iconClass;
  }

  get iconSize(): number {
    return this.accordion?.iconSize;
  }

  get iconArrow(): boolean {
    return this.accordion?.iconArrow;
  }

  constructor(@Optional() public accordion: BllAccordionWorkflowComponent) {
    super(accordion);
  }
}
